import React from 'react';

const BlockchainContext = React.createContext(undefined);

export default BlockchainContext;
